import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Closet from './pages/Closet';
import Studio from './pages/Studio';
import Demo from './pages/Demo';
import Settings from './pages/Settings';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="closet" element={<Closet />} />
          <Route path="studio" element={<Studio />} />
          <Route path="demo" element={<Demo />} />
          <Route path="calendar" element={
            <div className="flex items-center justify-center h-[calc(100vh-200px)] text-center">
              <div className="max-w-md p-10 border border-pearl-200 bg-white">
                <SafeIcon name="Calendar" className="w-12 h-12 mx-auto mb-6 text-graphite-300" />
                <h1 className="font-editorial text-3xl mb-4">Style Calendar</h1>
                <p className="font-mono text-xs text-graphite-500 leading-relaxed">
                  THE PREDICTIVE PLANNING MODULE IS CURRENTLY IN BETA. 
                  ROLLOUT EXPECTED FOR Q4 2024.
                </p>
                <button className="mt-8 btn-primary w-full py-3">JOIN WAITLIST</button>
              </div>
            </div>
          } />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;